import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './NotFound.css';

function NotFound() {
    const { t } = useTranslation();
    return (
        <div className="not_found_countainer">
            <h1 className="header">{t('not_found_code')}</h1>
            <h2 className="title">{t('not_found_title')}</h2>
            <p className="body">{t('not_found_body')}</p>
            <Link to="/" className="back_button">
                {t('back_home')}
            </Link>
        </div>
    );
}

export default NotFound;
